import { SubscriptionStatusType } from '../enums/subscription-status.enum';
import { Deserializable } from './deserializable.model';

export class SubscriptionStatus implements Deserializable<any, SubscriptionStatus> {
  constructor(
    public access?: boolean,
    public canceledDate?: string,
    public status?: SubscriptionStatusType,
    public trialEndDate?: string,
    public trialStartDate?: string
  ) {}

  deserialize(input: any): SubscriptionStatus {
    if (input == null) {
      return null;
    }

    this.access = input.access;
    this.canceledDate = input.canceledDate;
    this.status = input.status;
    this.trialEndDate = input.trialEndDate;
    this.trialStartDate = input.trialStartDate;

    return this;
  }
}
